import { Component } from '@angular/core';

// RxJS
import { Subject, takeUntil } from 'rxjs';

// Services
import { ProjectService } from '@modules/project/services/project.service';
import { UsersService } from '@modules/users/services/users.service';

// Types
import { MatDialogRef } from '@angular/material/dialog';
import { C3Station } from '@modules/project/types/c3-station';
import { UserPermissions } from '@modules/users/types/user';

@Component({
    selector: 'app-stations-list',
    templateUrl: './stations-list.component.html',
    styleUrl: './stations-list.component.less',
    standalone: false
})
export class StationsListComponent {

  // Public
  public stations: C3Station[] = [];
  public permissions?: UserPermissions[];
  public stationName = '';
  public stationId = '';
  
  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<StationsListComponent>,
    public projectService: ProjectService,
    private usersService: UsersService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    // Get Stations
    this.getStations();
    // Get Permissions
    this.usersService.getPermissions()
      .pipe(takeUntil(this.alive))
      .subscribe(permissions => this.permissions = permissions);
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  getStations(): void {
    this.projectService.getStations()
      .pipe(takeUntil(this.alive))
      .subscribe(stations => this.stations = stations);
  }

  /**
   * Actions
   */

  close(): void {
    this.dialogRef.close();
  }

  createStation(): void {
    if (this.stationName.length && this.stationId.length) {
      this.projectService.createStations([{stationName: this.stationName, stationId: this.stationId}])
        .subscribe(() => {
          this.stationName = '';
          this.stationId = '';
          this.getStations();
        });
    }
  }

  updateStation(station: C3Station): void {
    this.projectService.updateStation(station)
      .subscribe(() => this.getStations());
  }

  deleteStation(station: C3Station): void {
    if (station.id) {
      this.projectService.deleteStation(station.id)
        .subscribe(() => this.getStations());
    }
  }

}
